import { render } from "./TaxComparison.vue?vue&type=template&id=2eb6b3dc&scoped=true"
import script from "./TaxComparison.vue?vue&type=script&lang=js"
export * from "./TaxComparison.vue?vue&type=script&lang=js"

import "./TaxComparison.vue?vue&type=style&index=0&id=2eb6b3dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb6b3dc"]])

export default __exports__